import { createSlice } from '@reduxjs/toolkit';
import { setToStore } from '../utils/fn';
import constants from '../utils/constants.json';

export const userSlice = createSlice({
	name: 'user',
	initialState: {
		loggedIn: false,
		user: {},
	},
	reducers: {
		setUser: function (state, action) {
			state.user = action.payload;
			setToStore(constants.USER_PROFILE, action.payload);
		},

		setLoggedIn: function (state, action) {
			state.loggedIn = action.payload;
		},

		updateUser: function (state, action) {
			state.user = { ...state.user, ...action.payload };
			setToStore(constants.USER_PROFILE, state.user);
		},

		removeUser: function (state) {
			state.loggedIn = false;
			state.user = {};
		},
	},
});

export const { setUser, setLoggedIn, updateUser, removeUser } = userSlice.actions;
export default userSlice.reducer;
